export default {"src":"/_next/static/media/icon_shield.4361ab8d.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};